import { renderOtherSchoolResultEntry9Page } from '../result_entry_9.ts';

export async function renderOtherSchoolResultEdit9Page(app: HTMLElement): Promise<void> {
  // Leverage the query-aware Entry module for zero code duplication
  await renderOtherSchoolResultEntry9Page(app);
}
